// limit-one.js
document.addEventListener('DOMContentLoaded', () => {

  // ---------- Helper: check if limit-one item is in the cart ----------
  async function isLimitOneInCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    return cart.items.some(item => item.product.tags.includes('limit-one'));
  }

  // ---------- Intercept all add-to-cart forms ----------
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      const productTagsInput = form.querySelector('input[name="product_tags"]');
      const tags = productTagsInput ? productTagsInput.value.split(',') : [];
      
      if (tags.includes('limit-one')) {
        const alreadyInCart = await isLimitOneInCart();
        if (alreadyInCart) {
          e.preventDefault();
          alert('You can only have one of this product in your cart.');
        }
      }
    });
  });

  // ---------- Enforce limit-one on cart page ----------
  function enforceLimitOneCart() {
    document.querySelectorAll('.cart-item').forEach(row => {
      const tags = row.dataset.productTags ? row.dataset.productTags.split(',') : [];
      if (!tags.includes('limit-one')) return;

      const qtyInput = row.querySelector('input[name="updates[]"]');
      const plusBtn = row.querySelector('button[name="plus"]');
      const minusBtn = row.querySelector('button[name="minus"]');
      if (!qtyInput) return;

      // Force quantity to 1
      qtyInput.value = 1;
      qtyInput.setAttribute('max', 1);
      qtyInput.setAttribute('min', 1);

      // Hide plus and minus buttons
      if (plusBtn) plusBtn.style.display = 'none';
      if (minusBtn) minusBtn.style.display = 'none';

      // Prevent manual input > 1
      qtyInput.addEventListener('change', function() {
        if (parseInt(this.value) !== 1) this.value = 1;
      });
    });
  }

  // Run on initial cart page load
  if (document.querySelector('.cart-items')) {
    enforceLimitOneCart();
  }

  // Run after Shopify AJAX cart updates
  document.addEventListener('cart:updated', enforceLimitOneCart);

});
